export function toDegree(y,x){return Math.atan2(y,x)*(180/Math.PI);}